<template>
  <div name="demo-table-request">
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :maxRowspan="maxRowspan"
                :indexDisp="true"
                :requestDisp="true"
                :addEvent="addEvent"
                :editEvent="editEvent"
                :cancelEvent="cancelEvent"
                :requestCancelDisp="false"
                :nowLang="nowLang" />
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.approveLabels
let flgRowCondition = false
let mockMaxRowspan = 2
let mockColumns = mock.columns(labels, 'display', flgRowCondition)
let mockData = mock.dataApprove(flgRowCondition)

export default {
  name: 'demo-table-request',
  data () {
    return {
      nowLang: 'en',
      maxRowspan: mockMaxRowspan,
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData
    }
  },
  methods: {
    addEvent (dataRow) {
      console.log('Add Event')
    },
    editEvent (dataRow) {
      console.log('Edit Event')
    },
    cancelEvent (dataRow) {
      console.log('Cancel Event')
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableRequest.vue?c2ee8fc4